import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ContactService } from '../api-services/contact/contact.service';
import { keyService } from '../api-services/keycloak/service/key.service';
import { ProfileService } from '../api-services/profile/profile.service';
import * as appConstants from '../../assets/json/applicationConstants.json';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css']
})

/**
 * This component is using for user need any queries to contact
 * ayurls support team.
 * A user can submit their details and concern messages.
 */
export class ContactusComponent implements OnInit {
  brandData = appConstants?.commonAppConstants?.brandData;
  socialUrl = appConstants?.commonAppConstants?.socialUrl;
  @ViewChild('msg') modalRef: any;
  reqForm = new FormGroup({
    customerName: new FormControl("", [Validators.required, Validators.minLength(3), Validators.maxLength(35), Validators.pattern('^[a-zA-Z \-\']+')]),
    email: new FormControl("", [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]),
    phoneNumber: new FormControl("", [Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
    message: new FormControl("", [Validators.required])
  })
  loggedIn: boolean;
  loggedUser: string[];
  userDetails: any;
  constructor(private contactService: ContactService, private modalService: BsModalService, private login_service: keyService, private getDetails: ProfileService) { }

  async ngOnInit() {
    this.loggedIn = await this.login_service.isLoggedIn();
    if (this.loggedIn) {
      this.loggedUser = this.login_service.getRoles();
      if (this.loggedUser.includes('member')) {
        this.getDetails.getMemberProfile().subscribe(res => {
          this.userDetails = res;
          this.reqForm.get('customerName').patchValue(this.userDetails.firstName);
          this.reqForm.get('email').patchValue(this.userDetails.email);
          this.reqForm.get('phoneNumber').patchValue(this.userDetails.phoneNumber);
        })
      } else if (this.loggedUser.includes('doctor')) {
        this.getDetails.getDoctorProfile().subscribe(res => {
          this.userDetails = res;
          this.reqForm.get('customerName').patchValue(this.userDetails.firstName);
          this.reqForm.get('email').patchValue(this.userDetails.email);
          this.reqForm.get('phoneNumber').patchValue(this.userDetails.mobile);
        })
      }
    }
  }

  /**
   * This method to submit user information and message. 
   */
  reqContact() {
    if (!this.reqForm.valid) {
      return this.reqForm.markAllAsTouched()
    } else {
      this.contactService.postContact(this.reqForm.value).subscribe(res => {
        if (res) {
          this.reqForm.reset("");
          this.modalService.show(this.modalRef, {
            initialState: {
              message: 'It has been successfully submitted'
            }
          });
        }
      }, err => {
        if (err.status == 500) {
          this.modalService.show(this.modalRef, {
            initialState: {
              message: 'Unable to connect '
            }
          });
        }
      })
    }

  }

  modalClose() {
    this.modalService.config.initialState = "";
    this.modalService.hide();
  };


  
}
